import type { FC, ReactElement } from "react";
import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import type { MembershipWithInstallmentsDisclaimerProps } from "./contract";
import DISCLAIMER_KEYS from "./config/constants";

const MembershipWithInstallmentsDisclaimer: FC<
  MembershipWithInstallmentsDisclaimerProps
> = ({ autoRenewalPolicy }): ReactElement | null => {
  const { t } = useTranslation();
  if (!autoRenewalPolicy) return null;

  const disclaimerKey = DISCLAIMER_KEYS[autoRenewalPolicy];
  if (!disclaimerKey) return null;

  return <>{t(disclaimerKey)}</>;
};

export default MembershipWithInstallmentsDisclaimer;
